let page_type = document.querySelector('.wc_pagetype');
if (page_type.dataset.page == 'index') {
  page_type.dataset.page = 'home';
}
(function () {
  const blockedScripts = [
    '//www.powr.io/powr.js?powr-token=french-beauty-co.myshopify.com&external-type=shopify&shop=french-beauty-co.myshopify.com',
    'https://app.marsello.com/Portal/Custom/FormScriptToInstall/5ac5ad1e8e2bf30f709a9fae?aProvId=5ac5ad148e2bf30bb8ff51ce&formId=61de6f74c6076c4741757caf&shop=french-beauty-co.myshopify.com',
    'https://app.marsello.com/Portal/Widget/ScriptToInstall/5ac5ad1e8e2bf30f709a9fae?aProvId=5ac5ad148e2bf30bb8ff51ce&shop=french-beauty-co.myshopify.com',
    'https://cdn1.judge.me/assets/installed.js?shop=french-beauty-co.myshopify.com',
    'https://s3.eu-west-1.amazonaws.com/production-klarna-il-shopify-osm/94e9fff33480c47f1f4290009834e8a0d63e685a/french-beauty-co.myshopify.com-1724817908843.js?shop=french-beauty-co.myshopify.com',
    'https://d33a6lvgbd0fej.cloudfront.net/script_tag/secomapp.scripttag.js?shop=french-beauty-co.myshopify.com'
  ];

  const originalCreateElement = document.createElement;
  const blockedScriptElements = [];

  // Override document.createElement to intercept script creation
  document.createElement = function (tagName) {
    const scriptElement = originalCreateElement.call(document, tagName);
    if (tagName === 'script') {
      scriptElement.__defineGetter__('src', function () {
        return scriptElement.getAttribute('data-src');
      });

      scriptElement.__defineSetter__('src', function (value) {
        if (blockedScripts?.some((url) => value.includes(url))) {
          scriptElement.type = 'javascript/blocked';
          scriptElement.setAttribute('data-src', value); // Save the src for later
          blockedScriptElements.push(scriptElement); // Store the blocked script
          return; // Prevent the script from loading
        }
        scriptElement.setAttribute('src', value);
      });
    }
    return scriptElement;
  };

  // Function to load blocked scripts
  function loadBlockedScripts() {
    blockedScriptElements.forEach((script) => {
      const newScript = originalCreateElement.call(document, 'script');
      newScript.src = script.getAttribute('data-src');
      newScript.async = true;
      document.body.appendChild(newScript);
    });
    blockedScriptElements.length = 0; // Clear the list after loading
  }

  // Load scripts immediately on user interaction
  function onUserInteraction() {
    loadBlockedScripts();
    // Remove event listeners after the first interaction
    window.removeEventListener('scroll', onUserInteraction);
    window.removeEventListener('mousemove', onUserInteraction);
    document.removeEventListener('click', onUserInteraction);
  }

  // Add event listeners to trigger loading of blocked scripts after interaction
  window.addEventListener('scroll', onUserInteraction, { once: true });
  window.addEventListener('mousemove', onUserInteraction, { once: true });
  document.addEventListener('click', onUserInteraction, { once: true });

  // MutationObserver to detect when scripts are added to the DOM
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        addedNodes.forEach((node) => {
          if (node.tagName === 'SCRIPT' && node.src && blockedScripts?.some((url) => node.src.includes(url))) {
            node.type = 'javascript/blocked'; // Prevent loading
            node.setAttribute('data-src', node.src); // Store the source
            blockedScriptElements.push(node); // Save to the blocked scripts list
          }
        });
      }
    }
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, { childList: true, subtree: true });

  // Ensure scripts are loaded on page load if already in the DOM
  loadBlockedScripts();
})();